import RowButton from 'components/atoms/row-button'
import SelectTableFilter from 'components/atoms/select-table-filter'
import SellerOutboundReturnTypeBadge from 'domains/seller-outbound-return/atoms/return-type-badge'
import SellerOutboundReturnStatusBadge from 'domains/seller-outbound-return/atoms/status-badge'
import { RETURN_TYPE, STATUS } from 'domains/seller-outbound-return/constants'
import PropTypes from 'prop-types'
import React from 'react'

const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}


const filterPropTypes = {
  column: PropTypes.object
}

const humanizeOption = (value) => value
  .split('_')
  .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
  .join(' ')

const STATUS_FILTER_LABELS = {
  [STATUS.PENDING]         : 'Pending',
  [STATUS.ACCEPTED]        : 'Accepted',
  [STATUS.SCHEDULED]       : 'Shipped',
  [STATUS.SELLER_RECEIVED] : 'Seller Received',
  [STATUS.CANCELLED]       : 'Cancelled'
}

const STATUS_FILTER_OPTIONS = Object.values(STATUS).map((value) => ({
  label : STATUS_FILTER_LABELS[value] || humanizeOption(value),
  value
}))

const RETURN_TYPE_FILTER_OPTIONS = Object.values(RETURN_TYPE).map((value) => ({
  label : humanizeOption(value),
  value
}))

const sellerOutboundReturnTableColumns = ({
  buttonText,
  buttonColour,
  isButtonDisabled,
  onButtonClick,
  cancelButtonProps = {}
}) => {
  const ReturnTypeFilter = ({ column }) => (
    <SelectTableFilter reactTableColumn={ column } options={ RETURN_TYPE_FILTER_OPTIONS } />
  )

  ReturnTypeFilter.propTypes = filterPropTypes

  const StatusFilter = ({ column }) => (
    <SelectTableFilter reactTableColumn={ column } options={ STATUS_FILTER_OPTIONS } />
  )

  StatusFilter.propTypes = filterPropTypes

  const ReturnTypeCell = (row) => (
    <SellerOutboundReturnTypeBadge return_type={ row.cell.value } />
  )

  const StatusCell = (row) => (
    <SellerOutboundReturnStatusBadge status={ row.cell.value } />
  )

  const ProductSkuCell = (row) => {
    const value = row.cell.value
    const listItems = row.row.original?.list_items || []

    if (listItems.length > 0) {
      return (
        <div style={{ whiteSpace: 'normal', lineHeight: 1.45 }}>
          {
            listItems.map((item, index) => (
              <div key={ item.id || `${item.sku || 'sku'}-${index}` }>
                { item.sku || '-' }
              </div>
            ))
          }
        </div>
      )
    }

    if (Array.isArray(value)) {
      return value.map((sku, index) => (
        <div key={ `${sku}-${index}` }>{ sku || '-' }</div>
      ))
    }

    return value || '-'
  }

  const ProductNameCell = (row) => {
    const value = row.cell.value
    const listItems = row.row.original?.list_items || []

    if (listItems.length > 0) {
      return (
        <div style={{ whiteSpace: 'normal', lineHeight: 1.45 }}>
          {
            listItems.map((item, index) => (
              <div key={ item.id || `${item.product_name || 'product'}-${index}` }>
                { item.product_name || '-' }
              </div>
            ))
          }
        </div>
      )
    }

    return value || '-'
  }

  const CreatedAtCell = (row) => {
    const value = row.cell.value
    if (!value) return '-'

    const date = new Date(value)
    if (Number.isNaN(date.getTime())) return value

    return date.toLocaleString('sv-SE', {
      timeZone : 'Asia/Jakarta',
      year     : 'numeric',
      month    : '2-digit',
      day      : '2-digit',
      hour     : '2-digit',
      minute   : '2-digit',
      hour12   : false
    })
  }

  const ActionCell = ({ cell: { row } }) => {
    const data = row.original
    const disabled = isButtonDisabled ? isButtonDisabled(data) : false
    const cancelDisabled = cancelButtonProps.isButtonDisabled ? cancelButtonProps.isButtonDisabled(data) : false
    const hasRowButton = Boolean(buttonText && onButtonClick)

    return (
      <div className='d-flex flex-column align-items-start'>
        {
          hasRowButton ? (
            <RowButton
              data={ data }
              color={ buttonColour }
              disabled={ disabled }
              onClick={ onButtonClick }
              text={ buttonText }
            />
          ) : null
        }
        {
          cancelButtonProps.onButtonClick ? (
            <div className={ hasRowButton ? 'mt-2' : '' }>
              <RowButton
                data={ data }
                color={ cancelButtonProps.buttonColour || 'danger' }
                disabled={ cancelDisabled }
                onClick={ cancelButtonProps.onButtonClick }
                text={ cancelButtonProps.buttonText || 'Cancel' }
              />
            </div>
          ) : null
        }
      </div>
    )
  }

  ActionCell.propTypes = actionCellPropTypes

  return [
    {
      Header         : 'CODE',
      accessor       : 'code',
      disableFilters : true
    },
    {
      Header         : 'Created At',
      accessor       : 'created_at',
      disableFilters : true,
      Cell           : CreatedAtCell
    },
    {
      Header         : 'Nama Consignor',
      accessor       : 'seller.name',
      id             : 'seller_name',
      disableFilters : true
    },
    {
      Header         : 'SKU Product',
      accessor       : 'product_skus',
      disableFilters : true,
      Cell           : ProductSkuCell
    },
    {
      Header         : 'Product Name',
      accessor       : 'product_name',
      disableFilters : true,
      Cell           : ProductNameCell
    },
    {
      Header         : 'Qty',
      accessor       : 'quantity',
      disableFilters : true
    },
    {
      Header   : 'Return Type',
      accessor : 'return_type',
      Filter   : ReturnTypeFilter,
      Cell     : ReturnTypeCell
    },
    {
      Header   : 'Status',
      accessor : 'status',
      Filter   : StatusFilter,
      Cell     : StatusCell
    },
    {
      Header         : 'Action',
      accessor       : 'action',
      disableFilters : true,
      Cell           : ActionCell
    }
  ]
}

export default sellerOutboundReturnTableColumns